export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-1-960-dfc9e0a7085142bb7b5bed98f6ba21d1.png";